

export const pushProfile = (user) => {
  if (!window.clevertap) return;

  if (!user?.id) {
    console.log("❌ Missing Identity");
    return;
  }
  //window.clevertap.setLogLevel(3);

  window.clevertap.onUserLogin.push({
    Site: {
      Identity: String(user.id), // force string
      Name: user.name || "",
      Email: user.email || "",
      Phone: user.phone ? `+${user.phone}` : "",
      Role : user.role,
      Company : user?.company,
      "MSG-whatsapp": true,        // opt-in for WhatsApp
    "MSG-push": true, 
    },
  });

  console.log("✅ Profile pushed to CleverTap" , user);
};

export const pushEvent = (eventName, eventData = {}) => {
  if (!window.clevertap) return;

  window.clevertap.event.push(eventName, eventData);
};

export const clearProfile = () => {
  if (!window.clevertap) return;

  window.clevertap.logout();
};